"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCanEditLockedDashboardPermission = exports.selectCanEditDashboardPermission = exports.selectCanShareLockedDashboardPermission = exports.selectCanShareDashboardPermission = exports.selectCanViewDashboardPermission = exports.selectDashboardPermissions = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.dashboardPermissions; });
/**
 * This selector returns user's dashboard permissions.
 *
 * @remarks
 * It is expected that the selector is called only after the dashboard permission state is correctly initialized.
 * Invocations before initialization lead to invariant errors.
 *
 * If the permission is not supported by GoodData Cloud and GoodData.CN backends, the selector always returns `false` value.
 *
 * In case you need multiple permissions available in your application, use this common selector.
 *
 * @public
 */
exports.selectDashboardPermissions = toolkit_1.createSelector(selectSelf, function (state) {
    ts_invariant_1.default(state.dashboardPermissions, "attempting to access uninitialized dashboard permissions state");
    return state.dashboardPermissions;
});
/**
 * Returns whether the current user has permissions to view dashboard.
 *
 * @public
 */
exports.selectCanViewDashboardPermission = toolkit_1.createSelector(exports.selectDashboardPermissions, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.canViewDashboard) !== null && _a !== void 0 ? _a : false;
});
/**
 * Returns whether the current user has permissions to share dashboard.
 *
 * @public
 */
exports.selectCanShareDashboardPermission = toolkit_1.createSelector(exports.selectDashboardPermissions, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.canShareDashboard) !== null && _a !== void 0 ? _a : false;
});
/**
 * Returns whether the current user has permissions to share a locked dashboard.
 *
 * @public
 */
exports.selectCanShareLockedDashboardPermission = toolkit_1.createSelector(exports.selectDashboardPermissions, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.canShareLockedDashboard) !== null && _a !== void 0 ? _a : false;
});
/**
 * Returns whether the current user has permissions to edit dashboard.
 *
 * @public
 */
exports.selectCanEditDashboardPermission = toolkit_1.createSelector(exports.selectDashboardPermissions, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.canEditDashboard) !== null && _a !== void 0 ? _a : false;
});
/**
 * Returns whether the current user has permissions to edit locked dashboard.
 *
 * @public
 */
exports.selectCanEditLockedDashboardPermission = toolkit_1.createSelector(exports.selectDashboardPermissions, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.canEditLockedDashboard) !== null && _a !== void 0 ? _a : false;
});
//# sourceMappingURL=dashboardPermissionsSelectors.js.map